import { render } from "./cpt-checkbox-option.vue?vue&type=template&id=38b5e43f"
import script from "./cpt-checkbox-option.vue?vue&type=script&lang=js"
export * from "./cpt-checkbox-option.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__